import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'

import { supabase } from '@/lib/supabase/cliente'
import { mensajeDeError } from '@/lib/supabase/errores'
import type { Sede } from '@/lib/supabase/tipos-bd'

/**
 * La bodega: su ubicación y su geocerca.
 *
 * Es la sede con la que se compara la devolución de herramientas por QR
 * (fn_devolver_por_qr). Si la bodega se muda, aquí se corrige el punto y el
 * radio, y la devolución empieza a exigir el sitio nuevo sin tocar código.
 */
export function useBodega() {
  const consulta = useQuery({
    queryKey: ['bodega'],
    queryFn: async (): Promise<Sede | null> => {
      const { data, error } = await supabase
        .from('sedes')
        .select('*')
        .eq('nombre', 'Bodega')
        .maybeSingle()

      if (error) throw new Error(mensajeDeError(error))
      return (data as Sede) ?? null
    },
  })

  return { bodega: consulta.data ?? null, cargando: consulta.isLoading }
}

export function useGuardarBodega() {
  const clienteConsultas = useQueryClient()

  return useMutation({
    mutationFn: async ({
      id,
      direccion,
      latitud,
      longitud,
      radio_m,
    }: {
      id: string
      direccion: string
      latitud: number
      longitud: number
      radio_m: number
    }) => {
      const { error } = await supabase
        .from('sedes')
        .update({ direccion: direccion.trim(), latitud, longitud, radio_m } as never)
        .eq('id', id)

      if (error) throw new Error(mensajeDeError(error))
    },
    onSuccess: () => clienteConsultas.invalidateQueries({ queryKey: ['bodega'] }),
  })
}
